var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileWhiteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1176",
    "data-name": "Rectangle 1176",
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5315",
    "data-name": "Group 5315",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    fill: "white",
    "data-name": "Path 1860",
    d: "M275.755,377.509h6.036a.755.755,0,1,0,0-1.509h-6.036a.755.755,0,1,0,0,1.509Z",
    transform: "translate(-266.701 -363.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    fill: "white",
    "data-name": "Path 1861",
    d: "M275.755,301.509h2.263a.755.755,0,1,0,0-1.509h-2.263a.755.755,0,1,0,0,1.509Z",
    transform: "translate(-266.701 -290.946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    fill: "white",
    "data-name": "Path 1862",
    d: "M275.755,477.509h6.036a.754.754,0,1,0,0-1.509h-6.036a.754.754,0,1,0,0,1.509Z",
    transform: "translate(-266.701 -460.664)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    fill: "white",
    "data-name": "Path 1863",
    d: "M275.755,577.509h6.036a.754.754,0,1,0,0-1.509h-6.036a.754.754,0,1,0,0,1.509Z",
    transform: "translate(-266.701 -557.647)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    fill: "white",
    "data-name": "Path 1864",
    d: "M22.635,1.509H18.108a.755.755,0,0,0,0,1.509h4.527v16.6H20.372V6.036a1.51,1.51,0,0,0-1.509-1.509H16.6V1.509A1.51,1.51,0,0,0,15.09,0H1.509A1.51,1.51,0,0,0,0,1.509v16.6a1.478,1.478,0,0,0,1.509,1.509h.755a.755.755,0,0,0,0-1.509H1.512a.131.131,0,0,0,0-.015V1.509H15.09V4.527H5.282A1.51,1.51,0,0,0,3.773,6.036v16.6a1.51,1.51,0,0,0,1.509,1.509H18.863a1.51,1.51,0,0,0,1.509-1.509V21.126h2.264a1.51,1.51,0,0,0,1.509-1.509V3.018A1.51,1.51,0,0,0,22.635,1.509ZM1.509,18.108v0Zm17.354,4.527H5.282V6.036H18.863Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileWhiteIcon);
export default __webpack_public_path__ + "static/media/file-white-icon.435bc628f9e6c1d352a74afb038d60fd.svg";
export { ForwardRef as ReactComponent };